import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 19.247 19.244"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18.845 18.836a1.373 1.373 0 0 0 0-1.942l-3.668-3.668a.345.345 0 0 1-.049-.433 8.247 8.247 0 1 0-2.335 2.335.345.345 0 0 1 .433.044l3.668 3.668a1.373 1.373 0 0 0 1.951 0ZM2.768 8.251a5.493 5.493 0 1 1 5.493 5.493 5.493 5.493 0 0 1-5.493-5.493Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }